import { useApiClient } from '@/composables/useApiClient'

import type { AxiosResponse } from 'axios'
import type { GetAuthenticatedUserResponse } from '@/types/auth/Responses/GetAuthenticatedUserResponse'
import type { GetAuthenticatedUserProfileResponse } from '@/types/auth/Responses/GetAuthenticatedUserProfileResponse'
import type { AttemptLoginResponse } from '@/types/auth/Responses/AttemptLoginResponse'
import type {
  UpdateAuthenticatedUserProfileRequest,
} from '@/types/auth/Requests/UpdateAuthenticatedUserRequest'
import type {
  UpdateAuthenticatedUserPasswordRequest,
} from '@/types/auth/Requests/UpdateAuthenticatedUserPasswordRequest'
import type { AttemptLoginRequest } from '@/types/auth/Requests/AttemptLoginRequest'

export const useAuthAPI = () => {
  const {
    apiClient,
  } = useApiClient()

  const apiGetCSRFCookie = async () => {
    await apiClient.get('/sanctum/csrf-cookie')
  }

  const apiAttemptLogin = async (
    attemptLoginRequest: AttemptLoginRequest,
  ): Promise<AxiosResponse<AttemptLoginResponse>> => {
    return await apiClient.post('/api/login', attemptLoginRequest)
  }

  const apiLogout = async () => {
    return await apiClient.post('/api/logout')
  }

  const apiGetAuthenticatedUser = async (): Promise<AxiosResponse<GetAuthenticatedUserResponse>> => {
    return await apiClient.get('/api/auth-user')
  }

  const apiGetAuthenticatedUserProfile = async (): Promise<AxiosResponse<GetAuthenticatedUserProfileResponse>> => {
    return await apiClient.get('/api/auth-user/profile')
  }

  const apiUpdateAuthenticatedUserProfile = async (
    updateAuthenticatedUserProfileRequest: UpdateAuthenticatedUserProfileRequest,
  ): Promise<AxiosResponse<GetAuthenticatedUserProfileResponse>> => {
    return await apiClient.put('/api/auth-user/profile', updateAuthenticatedUserProfileRequest)
  }

  const apiUpdateAuthenticatedUserPassword = async (
    updateAuthenticatedUserPasswordRequest: UpdateAuthenticatedUserPasswordRequest,
  ): Promise<AxiosResponse> => {
    return await apiClient.put('/api/auth-user/password', updateAuthenticatedUserPasswordRequest)
  }

  return {
    apiGetCSRFCookie,
    apiAttemptLogin,
    apiLogout,
    apiGetAuthenticatedUser,
    apiGetAuthenticatedUserProfile,
    apiUpdateAuthenticatedUserProfile,
    apiUpdateAuthenticatedUserPassword,
  }
}
